import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { GemIcon, SparklesIcon, HeartIcon, WheatIcon } from 'lucide-react';
const pillars = [{
  title: 'Kvalitet',
  description: 'Råvaror vi tror på, hantverk vi står för.',
  icon: GemIcon
}, {
  title: 'Kreativitet',
  description: 'Klassiska smaker möter nya idéer.',
  icon: SparklesIcon
}, {
  title: 'Passion',
  description: 'Vi älskar det vi gör – varje dag.',
  icon: HeartIcon
}, {
  title: 'Hantverk',
  description: 'Allt bakas från grunden, med tid och omsorg.',
  icon: WheatIcon
}];
export function Pillars() {
  return <section className="w-full py-12 md:py-28 px-4" data-id="element-1224" data-mp="321rth7tqlel0">
      <div className="max-w-5xl mx-auto" data-id="element-1225" data-mp="370uxcoxzdere">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-sm tracking-[0.2em] uppercase text-[#7C8062] font-medium mb-3" data-id="element-1226" data-mp="36ztaln7lr3tu">
          Vad vi står för
        </motion.p>
        <motion.h2 initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-center text-2xl md:text-4xl font-serif text-[#1A1A1A] mb-8 md:mb-20" data-id="element-1227" data-mp="sdilw67ch52j">
          Dag in och dag ut
        </motion.h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-1228" data-mp="165fba2hmp0v8">
          {pillars.map((pillar, index) => {
          const IconComponent = pillar.icon;
          return <motion.div key={pillar.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.12
          }} className="flex flex-col items-center text-center" data-id="element-1229" data-mp="3vseahgqv684w" data-mpi={index}>
                <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-[#7C8062]/10 border border-[#7C8062]/20 flex items-center justify-center mb-3 md:mb-5" data-id="element-1230" data-mp="39l0tpfor9kcd">
                  <IconComponent className="w-4 h-4 md:w-5 md:h-5 text-[#7C8062]" data-id="element-1231" data-mp="30mgh8w9sg6wl" />
                </div>
                <h3 className="text-base md:text-xl font-serif text-[#1A1A1A] mb-2 md:mb-3" data-id="element-1232" data-mp="34oae0tgv4qrh">
                  {pillar.title}
                </h3>
                <div className="w-6 md:w-8 h-px bg-[#7C8062]/30 mb-2 md:mb-3" data-id="element-1233" data-mp="2qptv845q79sz" />
                <p className="text-[#1A1A1A]/60 text-xs md:text-sm leading-relaxed max-w-[160px] md:max-w-[200px]" data-id="element-1234" data-mp="2vlsq8alk7q2d">
                  {pillar.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}